import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface State {
  token: string | null;
  patientId: string | null;
  clientId: string | null;
  orgId: string | null;
  orgTenantId: string | null;
  apiKey: string | null;
  tenantId: string | null;
  redirectUrl: string | null;
  deeplinkData?: any;
  phoneNumber?: string | null;
  appointmentData?: any;
  appointmentBooked?: boolean;
  patient?: any;
  clinicInfo?: any;
  paymentsEnabled: boolean | false;
  showConsentAfterRegistration?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private state: State = {
    token: null,
    patientId: null,
    clientId: null,
    orgId: null,
    orgTenantId: null,
    tenantId: null,
    apiKey: null,
    redirectUrl: null,
    phoneNumber: null,
    deeplinkData: null,
    paymentsEnabled: false
  };

  // BehaviorSubjects to track form completion events
  private registrationCompletedSource = new BehaviorSubject<boolean>(false);
  private consentCompletedSource = new BehaviorSubject<boolean>(false);
  private stateSubject = new BehaviorSubject<State>(this.state);

  // Observables for other components to subscribe to
  registrationCompleted$: Observable<boolean> = this.registrationCompletedSource.asObservable();
  consentCompleted$: Observable<boolean> = this.consentCompletedSource.asObservable();
  state$: Observable<State> = this.stateSubject.asObservable();

  // * Family Lookup Response *
  private familyLookupResponseSubject = new BehaviorSubject<any[]>([]);
  familyLookupResponse$: Observable<any[]> = this.familyLookupResponseSubject.asObservable();

  constructor() {}

  // Method to get the entire state
  getState(): State {
    return this.state;
  }

  // Method to set the state with partial updates
  setState(newState: Partial<State>) {
    this.state = { ...this.state, ...newState };
    this.stateSubject.next(this.state);
  }

  // Mark registration as complete
  markRegistrationComplete() {
    this.registrationCompletedSource.next(true);
  }

  // Mark consent as complete
  markConsentComplete() {
    this.consentCompletedSource.next(true);
  }

  // Optional: Reset completion events
  resetCompletionEvents() {
    this.registrationCompletedSource.next(false);
    this.consentCompletedSource.next(false);
  }
  
  setPaymentsEnabled(paymentsEnabled: boolean) {
    this.state.paymentsEnabled = paymentsEnabled;
  }

  isPaymentsEnabled(): boolean {
    return this.state.paymentsEnabled;
  }

  // Method to update the family lookup response signal
  updateFamilyLookupResponse(response: any[]): void {
    this.familyLookupResponseSubject.next(response);
  }
}